module.exports = "<p>\n  emp-retirement-list-form works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list-form/emp-retirement-list-form.component.html
// module id = ./src/app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list-form/emp-retirement-list-form.component.html
// module chunks = main